import styled from "@emotion/styled";
import React from 'react';

import logo from "../../images/Logo.jpg";
import {root} from "./styles";


export const ImageLogo = styled.div`
    background-position: center;
    background-image: url(${logo});
    background-repeat: no-repeat;
    display: flex;
    flex: 1;
    height: 100%;
    background-size: contain;
`;


export const Logo: React.FC = () => {
    return (
        <div css={root}>
            <ImageLogo/>
        </div>
    );
};